import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { MetaDataStore } from './store';
import { MetaTitleActions } from './actions';


export class MetaTitleTag extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleTag: ''
    }
    this.store = new MetaDataStore();
  }
  shouldComponentUpdate(nextProps,nextState){
    return (nextState.titleTag!=this.state.titleTag)
  }
  componentDidMount(){
    let _this = ReactDOM.findDOMNode(this);
    if(document.head.querySelector('title')!=null) {
      $(document.head.querySelector('title')).remove();
    }
    let firstChild = document.head.firstChild;
    document.head.insertBefore(_this,firstChild);

  }
  render() {
    return (
        <title>{this.state.titleTag}</title>
    );
  }
}


export class MetaDescriptionTag extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: ''
    }
    this.store = new MetaDataStore();
  }
  shouldComponentUpdate(nextProps,nextState){
    return (nextState.descrption!=this.state.description)
  }
  componentDidMount(){
    let _this = ReactDOM.findDOMNode(this);
    if(document.head.querySelector('meta[name="description"]')!=null){
      $(document.head.querySelector('meta[name="description"]')).remove()
    }
    let firstChild = document.head.firstChild;
    document.head.insertBefore(_this,firstChild);

  }
  render() {
    const description = this.state.description.replace(/"/g, '&quote;');
    return (
      <meta name="description" content={description} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/page-content/meta-data-tags/meta-tags.jsx